export default function ChevronRightIcon() {
  return (
    <svg
      width="16"
      height="24"
      viewBox="0 0 16 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5.5 7L10.5 12L5.5 17" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  )
}

export function ChevronRightIconLarge() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 16 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5.5 7L10.5 12L5.5 17" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  )
}

export function ChevronRightIconPrimary() {
  return (
    <svg
      width="16"
      height="24"
      viewBox="0 0 16 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5.5 7L10.5 12L5.5 17" stroke="#F8494D" strokeWidth="2" />
    </svg>
  )
}
